export const CHANGE_TEXT = 'text_input/CHANGE_TEXT';
export const DECREASE_SUBMITTING_COUNTER =
  'text_input/DECREASE_SUBMITTING_COUNTER';
export const INCREASE_SUBMITTING_COUNTER =
  'text_input/INCREASE_SUBMITTING_COUNTER';
export const IS_INVALID_INPUT = 'text_input/IS_INVALID_INPUT';
